<template>
    <div class="views-wrapper">
        <crud-table :actions="actions" :show-search="showSearch" search-placeholder="ابحث بمعرف الطالب (ID)" hide-create server-pagination :page-count="views.meta ? views.meta.last_page : 1" :current-page="views.meta ? views.meta.current_page : 1" :total="views.meta ? views.meta.total : undefined" :per-page="views.meta ? views.meta.per_page : undefined" title-icon="mdi-eye-outline" title="المشاهدات" :items="viewsItemsComputed" :headers="headers" @ignore="openIgnoreDialog" @delete="openDeleteDialog" @search="search" @load="loadMore" @reset="reset">
            <template slot="header-actions">
                <inertia-link v-if="allHref" as="v-btn" color="primary" depressed :href="allHref" :disabled="!viewsItems || viewsItems.length === 0">
                    <v-icon size="20" left>mdi-eye-outline</v-icon>
                    <span v-if="pcOnly">عرض كل المشاهدات</span>
                    <span v-else>الكل</span>
                </inertia-link>
            </template>
        </crud-table>

        <action-dialog v-model="ignoreDialog" action="put" :url="`/videos/views/${ignoreView ? ignoreView.id : ''}`" :data="ignoreView ? {ignored: !ignoreView.ignored} : {}" :title="ignoreView && ignoreView.ignored ? 'احتساب المشاهدة' : 'إلغاء المشاهدة'" button-text="تأكيد" :button-color="ignoreView && ignoreView.ignored ? 'success' : 'error'" @sync="syncItem">
            <div v-if="ignoreView">
                <div class="strong-text--text">
                    <span v-if="ignoreView.ignored">
                        هل أنت متأكد من احتساب المشاهدة الخاصة بالطالب <b class="strong-text--text">"{{ignoreView.userName}}"</b> ؟
                    </span>
                    <span v-else>
                        هل أنت متأكد من إلغاء المشاهدة الخاصة بالطالب <b class="strong-text--text">"{{ignoreView.userName}}"</b> ؟
                    </span>
                </div>
            </div>
        </action-dialog>

        <action-dialog v-model="deleteDialog" action="delete" :url="`/videos/views/${deleteView ? deleteView.id : ''}`" title="حذف المشاهدة نهائياً" button-text="تأكيد الحذف" button-color="error" @sync="deleteItem(deleteView.id)">
            <div v-if="deleteView">
                <div class="strong-text--text">
                    هل أنت متأكد من الحذف النهائي للمشاهدة الخاصة بالطالب <b class="strong-text--text">"{{deleteView.userName}}"</b> ؟
                </div>
            </div>
        </action-dialog>
    </div>
</template>

<script>
import CrudTable from '@/components/default/crud-table'

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    name: 'VideoViewsTable',
    components: {
        CrudTable,
    },
    props: {
        views: {},
        page_url: {},
        allHref: {},
        showSearch: {type: Boolean, default: false},
    },
    data() {
        return {

            deleteDialog: false,
            deleteView: null,

            ignoreDialog: false,
            ignoreView: null,

            viewsItems: null,

            headers: [
                {
                    text: 'عمليات',
                    value: 'actions',
                    align: 'start',
                    sortable: false
                },
                {
                    text: '#',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                },
                {
                    text: 'الطالب',
                    align: 'center',
                    sortable: false,
                    value: 'userName',
                    // button: 'userUrl',
                    // color: 'link'
                },
                {
                    text: 'الفيديو',
                    align: 'center',
                    sortable: false,
                    value: 'videoName',
                    button: 'videoPageUrl',
                    color: 'link',
                },
                {
                    text: 'الحالة',
                    align: 'center',
                    sortable: false,
                    value: 'status',

                    chip: true,
                    chipFunction: (status)=>{
                        if (status === 'canceled'){
                            return {text: 'ملغي', color: 'muted', icon: 'mdi-eye-off-outline'}
                        }else{
                            return {text: 'مشاهدة', color: 'primary', icon: 'mdi-eye'}
                        }
                    },
                },
                {
                    text: 'المنصة',
                    align: 'center',
                    sortable: false,
                    value: 'platform',

                    chip: true,
                    chipFunction: (platform)=>{
                        if (platform === 'app'){
                            return {text: 'تطبيق الهاتف', color: 'green darken-1', icon: 'mdi-cellphone-play'}
                        }else if (platform === 'android'){
                            return {text: 'تطبيق أندرويد', color: 'green darken-2', icon: 'mdi-android'}
                        }else if (platform === 'ios'){
                            return {text: 'تطبيق IOS', color: 'black', icon: 'mdi-cellphone-play'}
                        }else if (platform === 'desktop'){
                            return {text: 'برنامج ديسكتوب', color: 'blue darken-3', icon: 'mdi-monitor'}
                        }
                    },
                },
                {
                    text: 'وقت المشاهدة',
                    value: 'created_at',
                    time: true,
                    align: 'center',
                    sortable: false,
                },
            ],
        }
    },
    computed: {
        viewsItemsComputed(){
            return this.viewsItems.map(view=>{
                return {
                    ...view,
                    videoName: view.video ? view.video.full_name : '__',
                    videoPageUrl: view.video ? `/videos/${view.video.id}` : '',
                    userName: view.user ? view.user.name : '__',
                    userUrl: view.user ? `/users/${view.user.id}` : null,
                }
            });

        },
        actions(){
            let actions = [
                {name: 'ignore', text: 'إلغاء المشاهدة', icon: 'mdi-eye-off', color: 'muted', disabled: 'ignored'},
                {name: 'delete', text: 'حذف نهائي', icon: 'mdi-delete', color: 'error'},
            ];
            return actions;
        },
        viewTypesItems(){
            let types = [{text: 'Vimeo', value: 'vimeo'}];
            if (this.appData.enable_youtube_views){
                types.push({text: 'Youtube', value: 'youtube'});
            }
            return types;
        },
        ...GlobalComputed,
    },
    watch: {
        views(views){
            this.viewsItems = views.data;
        }
    },
    methods: {
        ...GlobalMethods,
        loadMore(payload){
            const page = payload.page;
            this.$emit('loadMore', page);
        },
        search(query){
            this.$inertia.visit(`${this.page_url}?query=${query}`);
        },
        reset(){
            this.$inertia.visit(this.page_url);
        },

        addItem(item){
            this.viewsItems.push(item);
        },
        syncItem(newItem){
            this.viewsItems = this.viewsItems.map(item=>{
                if (item.id === newItem.id){
                    return Object.assign(item, newItem);
                }
                return item;
            })
        },
        deleteItem(id){
            this.viewsItems = this.viewsItems.filter(item=>{
                return item.id !== id;
            })
        },
        editAction(){

        },
        openIgnoreDialog(view){
            this.ignoreDialog = true;
            this.ignoreView = view;
        },
        openDeleteDialog(view){
            this.deleteDialog = true;
            this.deleteView = view;
        },
    },
    created(){
        this.viewsItems = this.views.data;
    }
}

</script>
